import { userDefinedFields } from "../formFields.js/PurchaseOrderFields";
import GenericFormTabPo from "./GenericFormTabPo";

export default function UserDefinedTab({ formData, onChange, readOnly = false, formSubmissionAttempted }) {
  return <GenericFormTabPo fields={userDefinedFields} formData={formData} onChange={onChange} readOnly={readOnly} formSubmissionAttempted={formSubmissionAttempted} />;
}